import React from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import { toastError } from '../funciones';
import BadgesUsadas from './BadgesUsadas';
import FormInput from './FormInput';

function DatosRepresentante(props){

    function eliminarRepresentante(option){
        props.setRepresentantes(props.representantes.filter(item => item !== option));
    }

    function agregarRepresentante(){
        const apellidoInput = document.getElementById("apellidoRepresentante");
        const nombreInput = document.getElementById("nombreRepresentante");
        const cargoInput = document.getElementById("cargoRepresentante");
        const apellido = apellidoInput.value;
        const nombre = nombreInput.value;
        const cargo = cargoInput.value;
        if(apellido && nombre && cargo){
            props.setRepresentantes([...props.representantes, {apellido: apellido, nombre: nombre, 
                cargo: cargo, label: apellido + ", " + nombre + " / " + cargo}]);
            apellidoInput.value = nombreInput.value = cargoInput.value = "";
        }
        else    
            toastError("Debe completar los datos del representante");
    }
    return(  
        <>  
            <div id="datosRepresentante" className='d-none'>
                {props.text !== undefined?
                    <div className='row '>
                    <div className='offset-sm-1'>
                        <div class="mb-3">
                            <label class="form-label letraDatos">{props.text}</label>
                        </div>
                    </div>
                </div>
                :
                <>
                </>}
                <div className='row'>
                    <FormInput id={"nombreRepresentante"} text={"Nombre"} type={"text"} className={"col-md col-12 offset-sm-1 col-sm-10"}/>
                    <FormInput id={"apellidoRepresentante"} text={"Apellido"} type={"text"} className={"col-md col-12 offset-sm-1 col-sm-10 offset-md-0"} />
                    <FormInput id={"cargoRepresentante"} text={"Cargo"} type={"text"} className={"col-md col-12 offset-sm-1 col-sm-10 offset-md-0"}/>  
                    <div className='col-1'></div>
                </div>
                <div className="text-center pb-4 pt-2">
                    <div className='col'>
                        <button class="btn colorPrincipal text-white bold-botones btn-cuadrado" type="submit" onClick={agregarRepresentante}>Agregar Representante</button>
                    </div>
                </div>
                <div className='row'> 
                    <div className='col offset-sm-1'>
                        <BadgesUsadas badges={props.representantes} funcion={eliminarRepresentante}/>  
                    </div>   
                    <div className='col-1'></div>      
                </div>
            </div>
        </>
    );
}


export default DatosRepresentante;